import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { EventService } from '../../services/event.service';
import { WalletConnectService } from '../../services/wallet-connect.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  
  isLoaded: boolean = false;
  isMobile: boolean = false;
  windowSize: number = 0;
  currId: number | undefined;
  notificationUrl = environment.sseUrl

  lang: any;
  
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (isPlatformBrowser(this._platformId)) {
      this.windowSize = window.innerWidth;
      this.isMobile = this.windowSize <= 1024 ? true : false;
    }
  }

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private eventService: EventService,
    private translate: TranslateService,

  ) {
    this.eventService.getEvent('SLIDETO').subscribe((param: any) => {
      this.currId = param;
    });
    
    if (isPlatformBrowser(this._platformId)){
     const section = window.location.hash.replace("#","");
     this.currId = this.eventService.sliderArr.findIndex((x) => x === section);
    }
     this.eventService.getLang().subscribe((val) => {
          this.lang = val || 'en';
        });
        
        this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
          this.lang = params.lang;
        });
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this._platformId)) {
      this.lang = this.translate.currentLang;
      this.windowSize = window.innerWidth;
      this.isMobile = this.windowSize <= 1024 ? true : false;
      this.isLoaded = true;
    }
  }

}
